import { render } from "./UpdateMemberPremiumImpact.vue?vue&type=template&id=9e4bf348&scoped=true"
import script from "./UpdateMemberPremiumImpact.vue?vue&type=script&lang=js"
export * from "./UpdateMemberPremiumImpact.vue?vue&type=script&lang=js"

import "./UpdateMemberPremiumImpact.vue?vue&type=style&index=0&id=9e4bf348&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e4bf348"]])

export default __exports__